module.exports = __webpack_public_path__ + "media/images/mobile/223-f24a99898c2665c154f155e0130b4865.jpg";